export default __webpack_public_path__ + "static/media/Hold.36edd710.svg";